"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dimensions_1 = __importDefault(require("./dimensions")); // import { getMinFromArrayOfNumbers } from './validation';


var CutOutShapes;

(function (CutOutShapes) {
  CutOutShapes["Round"] = "ROUND";
  CutOutShapes["Square"] = "SQUARE";
  CutOutShapes["Flap"] = "FLAP";
})(CutOutShapes = exports.CutOutShapes || (exports.CutOutShapes = {}));

var cutOutDisposalsType;

(function (cutOutDisposalsType) {
  cutOutDisposalsType["Waste"] = "WASTE";
  cutOutDisposalsType["Custom"] = "CUSTOM";
  cutOutDisposalsType["Provider"] = "PROVIDER";
})(cutOutDisposalsType = exports.cutOutDisposalsType || (exports.cutOutDisposalsType = {}));

exports.buildCutOutSpec = function (key, conf, positionIndex) {
  if (!key) {
    key = 'FALLBACK';
  }

  var cutout = {
    key: key || 'FALLBACK',
    dimensions: {
      depth: 10,
      width: 10
    },
    reqDimensions: {
      apron: null,
      depth: 10,
      width: 10
    },
    buffer: {
      front: 0,
      left: 0,
      right: 0
    },
    shape: CutOutShapes.Round,
    type: cutOutDisposalsType.Waste,
    withRail: false,
    withBasket: false,
    withSleeve: false,
    parts: []
  }; // Paper towel dispenser... its not cosmetic tissue dispenser, that one sits on the front

  if (key === 'PROVIDER') {
    return {
      key: key,
      dimensions: {
        depth: 286,
        width: 165
      },
      reqDimensions: {
        apron: null,
        depth: 330,
        width: 180
      },
      buffer: {
        front: 0,
        left: 0,
        right: 0
      },
      shape: CutOutShapes.Square,
      type: cutOutDisposalsType.Provider,
      withRail: false,
      withBasket: false,
      withSleeve: false,
      parts: ['provider']
    };
  }

  if (key === 'COSMETIC') {
    return {
      key: key,
      dimensions: {
        depth: dimensions_1.default.techSpecs.apronThickness,
        width: dimensions_1.default.installaionParts.tissueDispenserCutWidth
      },
      reqDimensions: {
        apron: null,
        depth: dimensions_1.default.techSpecs.apronThickness,
        width: dimensions_1.default.installaionParts.tissueDispenserWidth
      },
      buffer: {
        front: 0,
        left: 0,
        right: 0
      },
      shape: CutOutShapes.Square,
      type: cutOutDisposalsType.Provider,
      withRail: false,
      withBasket: false,
      withSleeve: false,
      parts: ['tissuedispenser']
    };
  } // Dimensions


  if (key.includes('ROUND')) {
    cutout.shape = CutOutShapes.Round;
    cutout.dimensions.width = 135;
    cutout.dimensions.depth = 135;
    cutout.reqDimensions.width = cutout.dimensions.width;
    cutout.reqDimensions.depth = cutout.dimensions.depth;
  }

  if (key.includes('SQUARE')) {
    cutout.shape = CutOutShapes.Square;
    cutout.dimensions.width = 162;
    cutout.dimensions.depth = 162;
    cutout.reqDimensions.width = cutout.dimensions.width;
    cutout.reqDimensions.depth = cutout.dimensions.depth;
  }

  if (key.includes('FLAP')) {
    cutout.shape = CutOutShapes.Flap;
    cutout.dimensions.width = 160;
    cutout.dimensions.depth = 280;
    cutout.reqDimensions.width = 200;
    cutout.reqDimensions.depth = 330;
    cutout.parts = cutout.parts.concat(['flap']);
  } // Custom


  if (key.includes('CUSTOM') && conf && conf.builtInParts && conf.builtInParts.cutOutDisposalsCustomSettings) {
    cutout.dimensions.width = conf.builtInParts.cutOutDisposalsCustomSettings.width;
    cutout.dimensions.depth = conf.builtInParts.cutOutDisposalsCustomSettings.depth;
    cutout.reqDimensions.width = cutout.dimensions.width;
    cutout.reqDimensions.depth = cutout.dimensions.depth;
    cutout.buffer.left = dimensions_1.default.techSpecs.individualRecessBuffer.round / 2;
    cutout.buffer.right = dimensions_1.default.techSpecs.individualRecessBuffer.round / 2;
  } // Extra


  if (key.includes('SLEEVE')) {
    cutout.withSleeve = true; // cutout.reqDimensions.width = cutout.reqDimensions.width + 15;
    // cutout.reqDimensions.depth = cutout.reqDimensions.depth + 15;

    if (key.includes('SQUARE')) {
      cutout.parts = cutout.parts.concat(['square_sleeve']);
      cutout.buffer.left = dimensions_1.default.techSpecs.individualRecessBuffer.round / 2;
      cutout.buffer.right = dimensions_1.default.techSpecs.individualRecessBuffer.round / 2;
    }

    if (key.includes('ROUND')) {
      cutout.parts = cutout.parts.concat(['round_sleeve']);
      cutout.buffer.left = dimensions_1.default.techSpecs.individualRecessBuffer.round / 2;
      cutout.buffer.right = dimensions_1.default.techSpecs.individualRecessBuffer.round / 2;
    }
  }

  if (key.includes('RAIL')) {
    cutout.withRail = true;
    cutout.reqDimensions.width = 300;
    cutout.reqDimensions.depth = 430;
    cutout.buffer.left = 0;
    cutout.buffer.right = 0;
    cutout.reqDimensions.apron = {
      min: 25,
      max: 150
    };
    cutout.buffer.front = 40; // Have to check if cutout is in same position as cosmetictissuedispenser... but how? we dont have cutout index at this point, aghh

    var hasTissueWithRail = typeof positionIndex !== 'undefined' && conf && conf.hasCutOutAtIndex(positionIndex) && conf.hasTissueDispenserAtIndex(positionIndex); // const hasShortOrNoRail = !conf || !conf.apronBackSplash || !conf.apronBackSplash.apronHeight || conf.apronBackSplash.apronHeight <= 60;

    var hasTallApron = conf && conf.apronBackSplash && conf.apronBackSplash.apronHeight && conf.apronBackSplash.apronHeight > 60;
    var hasSleeve = key.includes('SLEEVE');

    if (hasTissueWithRail) {
      cutout.parts = cutout.parts.concat(['rail_150_withcosmetic']);
    } else if (!hasTallApron && !hasSleeve) {
      cutout.parts = cutout.parts.concat(['rail_60']);
    } else {
      cutout.parts = cutout.parts.concat(['rail_150']);
    }
  }

  if (key.includes('BASKET')) {
    cutout.withBasket = true;
    cutout.parts = cutout.parts.concat(['basket']);
  }

  return cutout;
};

exports.cutOuts = function (conf) {
  // const withTissueDispenser = builtInParts && builtInParts.tissueDispenser ? true : false;
  // Technically this function shouldnt need to exist I think...
  // Old code gets all the cutouts, then filters them to find the one it needs, when really it could just call "buildCutOut"
  var cuts = [exports.buildCutOutSpec('FALLBACK', conf), exports.buildCutOutSpec('CUSTOM_ROUND', conf), exports.buildCutOutSpec('CUSTOM_SQUARE', conf), exports.buildCutOutSpec('ROUND_SLEEVE', conf), exports.buildCutOutSpec('SQUARE_SLEEVE', conf), exports.buildCutOutSpec('ROUND_BASKET', conf), exports.buildCutOutSpec('ROUND_RAIL', conf), exports.buildCutOutSpec('SQUARE_BASKET', conf), exports.buildCutOutSpec('SQUARE_RAIL', conf), exports.buildCutOutSpec('ROUND_SLEEVE_BASKET', conf), exports.buildCutOutSpec('ROUND_SLEEVE_RAIL', conf), exports.buildCutOutSpec('SQUARE_SLEEVE_BASKET', conf), exports.buildCutOutSpec('SQUARE_SLEEVE_RAIL', conf), exports.buildCutOutSpec('FLAP', conf), exports.buildCutOutSpec('FLAP_BASKET', conf), exports.buildCutOutSpec('FLAP_RAIL', conf), exports.buildCutOutSpec('PROVIDER', conf), exports.buildCutOutSpec('COSMETIC', conf)];
  return cuts;
};

exports.default = exports.cutOuts;